export const UPDATE_TABLE_CONFIG_REQUEST = 'UPDATE_TABLE_CONFIG_REQUEST';

export const updateTableConfigRequest = ( tableConfig ) => ({
    type: UPDATE_TABLE_CONFIG_REQUEST,
    payload: { tableConfig  }
});
